module.exports = __webpack_public_path__ + "1ed3d16db49ecf71013da07cf71c80c6.png";